module.exports = __webpack_public_path__ + "img/idle.fed11710.png";